export default __webpack_public_path__ + "static/media/FI.18e43f40.svg";